export default __webpack_public_path__ + "static/media/DSC_0846.d6e5147f.JPG";